function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map,
        icon: '/wp-content/themes/frenchify-sc/assets/img/layout/map-marker.png'
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        /*var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        infowindow.open( map, marker );

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });*/
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

$(document).ready(function() {

    // OFI
    objectFitImages();

    /*
        BLOCS
     */
    if ($('.header-slider-block').length > 0) {
        $('.header-slider-block .owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            navText: ["<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-left-red.svg' />", "<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-right-red.svg' />"],
            dots: true,
            animateOut: 'fadeOut',
            autoplay: true,
            autoplayTimeout: 4000,
            lazyLoadEager: 1,
            responsive : {
                991 : {
                    nav: true
                }
            }
        });
    }

    if ($('.brands-carousel-block').length > 0) {
        $('.brands-carousel-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: false,
            navText: ["<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-left-red.svg' />", "<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-right-red.svg' />"],
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            margin: 30,
            responsive : {
                768 : {
                    items: 3,
                    nav: true,
                },
                991 : {
                    items: 4,
                    nav: true,
                },
                1199 : {
                    items: 5,
                    nav: true,
                }
            }
        });
    }

    if ($('.imitations-carousel-block').length > 0) {
        $('.imitations-carousel-block .owl-carousel').owlCarousel({
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-left-red.svg' />", "<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-right-red.svg' />"],
            dots: false,
            autoplay: true,
            autoplayTimeout: 4000,
            margin: 30,
            autoWidth: true,
            responsive : {
                991 : {
                    margin: 60,
                }
            }
        });
    }

    if ($('.realisations-carousel-block').length > 0) {
        $('.realisations-carousel-block .owl-carousel').owlCarousel({
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-left-white.svg' />", "<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-right-white.svg' />"],
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            margin: 30,
            autoWidth: true,
            responsive : {
                991 : {
                    margin: 60,
                }
            }
        });

        $('.realisations-carousel-block .realisation .read-more').on('click', function() {
            $(this).closest('.realisation').find('.overlay').fadeToggle();
            return false;
        });
    }

    if ($('.team-block').length > 0) {
        $('.team-block .owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: true,
            autoplay: true,
            center: true,
            autoplayTimeout: 4000,
            margin: 0,
            responsive : {
                991 : {
                    items: 2
                },
                1199 : {
                    items: 3
                }
            }
        });
    }

    if ($('.two-columns-slider-text-block').length > 0) {
        $('.two-columns-slider-text-block .owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: true,
            navText: ["<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-left-red.svg' />", "<img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-right-red.svg' />"],
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            margin: 0
        });
    }

    if ($('.masonry-grid-block').length > 0) {
        var $grid = $('.masonry-grid-block .grid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
            $grid.masonry('layout');
        });

        $('.masonry-grid-block .grid-item').on('click', function() {
           $(this).closest('.masonry-grid-block').find('.carousel-popup').fadeIn();
           $('body, html').css('overflow', 'hidden');
           return false;
        });

        $('.masonry-grid-block .carousel-popup .close-popup').on('click', function() {
            $(this).closest('.carousel-popup').fadeOut();
            return false;
        });

        $('.masonry-grid-block .carousel-popup .owl-carousel').owlCarousel({
            items: 3,
            loop: true,
            nav: true,
            navText: ["<span class='img-wrapper'><img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-left-white.svg' /></span> Précédent", "Suivant <span class='img-wrapper'><img src='/wp-content/themes/frenchify-sc/assets/svg/layout/arrow-right-white.svg' /></span>"],
            dots: false,
            autoplay: false,
            margin: 75,
            center: true,
        });
    }

    $(document).on('click', '.wpcf7-form-control-wrap.photo .preview', function(e) {
        $(this).next().click();

        return false;
    });

    $(document).on('click', '#realisations .realisation .read-more', function() {
        $(this).closest('.realisation').find('.overlay').fadeToggle();
        return false;
    });

    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function(e) {
                $(input).prev().attr('src', e.target.result);
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    $(".wpcf7-form-control-wrap.photo input[type='file']").change(function() {
        readURL(this);
    });

    /*
        GLOBAL
     */
    $(".fancybox").fancybox();

    if ($('.map-contact-form-block #map').length > 0) {
        var map = initMap($('.map-contact-form-block #map'));
    }

    $(window).on('scroll', function() {
        var scroll = $(window).scrollTop();

        if (scroll > 0) {
            $('header#header').addClass('scroll');
        } else {
            $('header#header').removeClass('scroll');
        }
    });

    var scroll = $(window).scrollTop();

    if (scroll > 0) {
        $('header#header').addClass('scroll');

    } else {
        $('header#header').removeClass('scroll');
    }
});